import { Component, inject, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LossRunReviewViewModel } from '@program-suite/data-common/program';

@Component({
  selector: 'lib-ui-loss-runs-review',
  imports: [CommonModule],
  templateUrl: './ui-loss-runs-review.component.html',
  styleUrl: './ui-loss-runs-review.component.scss',
})
export class UiLossRunsReviewComponent {
  model = input.required<LossRunReviewViewModel>();
}
